
export enum AccountStatus { 
    notVerified = 201,
    verified = 202,
    locked = 203,
    accountNotFound = 204,
    active = 205
}

